import { render, staticRenderFns } from "./PasswordChangePopup.vue?vue&type=template&id=0c632ab7&"
import script from "./PasswordChangePopup.vue?vue&type=script&lang=js&"
export * from "./PasswordChangePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports